import { create } from "zustand"

interface SupportWidgetStore {
	isForcedOpen: boolean
	forceOpen: () => void
	release: () => void
}

export const useSupportWidgetStore = create<SupportWidgetStore>()((set) => ({
	isForcedOpen: false,
	forceOpen: () => {
		set({ isForcedOpen: true })
	},
	release: () => {
		set({ isForcedOpen: false })
	},
}))

// On a phone the controller keeps the widget disabled while the drawer is
// closed, so the entry enables it first; the "closed" event releases the hold.
export function toggleSupportWidget(): void {
	useSupportWidgetStore.getState().forceOpen()
	// @ts-expect-error Global widget calls
	// eslint-disable-next-line
	window.Productlane.enable()
	// @ts-expect-error Global widget calls
	// eslint-disable-next-line
	window.Productlane.toggle()
}
